import { t } from "i18next";
import { getMany, softDeleteById } from "services/salary_tax_rate";
import { Util } from "common/util";
import withDataTable from "../withDataTable";
import FormInsertOrUpdate from "./FormInsertOrUpdate";

const pathName = "/setting/salary-tax-rate";
const columns = [
  {
    title: t("text_monthly_salary"),
    dataIndex: "from",
    key: "from",
    render: (from, record) => {
      if (record.to) return `${Util.getInstance().formatCurrencyKHR(from)} - ${Util.getInstance().formatCurrencyKHR(record.to)}`;
      if (record.from && !record.to) return `Over ${Util.getInstance().formatCurrencyKHR(from)}`;
    }
  },
  {
    title: t("text_tax_rate"),
    dataIndex: "rate",
    key: "rate",
    render: (rate) => rate ? `${rate}%`: "0%"
  },
 
];

const size = new URLSearchParams(document.location.search).get("size");
const current = new URLSearchParams(document.location.search).get("current");
let defaultCurrent = 1;
let defaultPageSize = 10;

if (current) {
  defaultCurrent = current;
}

if (size) {
  defaultPageSize = size;
}

const handleSearch = (e) => {
  const queryParams = new URLSearchParams(document.location.search);
  const value = e.target.value;
  if (value) {
    queryParams.set("search", value);
  } else {
    queryParams.delete("search");
  }
  Util.getInstance().pushParamsToURL(pathName, queryParams.toString());
};

const getData = () => {
  let limit = defaultPageSize;
  let current = defaultCurrent;
  let option = {};
  const params = new URLSearchParams(document.location.search);
  const searchStr = params.get("search");

  if (params.get("size")) {
    limit = params.get("size");
  }

  if (params.get("current")) {
    current = params.get("current");
  }

  option["limit"] = limit;
  option["offset"] = (current - 1) * limit;

  if (searchStr) {
    option["search"] = searchStr;
  }

  return getMany(option);
};

export default withDataTable({
  title: t("text_salary_tax_rate"),
  columns,
  defaultCurrent,
  defaultPageSize,
  getData,
  handleSearch,
  pathName,
  showPagination: true,
  handleAddNew: (modalRef) => modalRef.showModal(),
  handleShowUpdate: (id, modalRef) => modalRef.showModal(id),
  FormInsertOrUpdate,
  confirmSoftDelete: (id) => softDeleteById(id),
});
